import apiAddress from "../_sig_api/_apiadress";
import createOptions from "../_helper/createOptions";
import {s_char_skills} from "../_signals/s_char";
import {ICharSkill} from "../_interfaces/ICharSkill";

export const SkillsGet = (cid: string) => {
    fetch(apiAddress + "/char/skills/" + cid, createOptions('GET'))
        .then((res) => res.json())
        .then((data) => {
                console.log('BEskills get reponse', data);
                if (data.hasOwnProperty('result')) {
                    s_char_skills.value = (data.result as ICharSkill[])
                }
            }
        )
        .catch((reason => {
            console.log('BESkills get catch', reason);
        }))
}

export const SkillsCreate = (skill: ICharSkill) => {
    fetch(apiAddress + "/char/skills/", createOptions('CREATE', skill))
        .then((res) => res.json())
        .then((data) => console.log('BESkills create reponse', data))
        .catch((reason => console.log('BESkills create catch', reason)))
}

export const SkillsUpdate = (skill: ICharSkill) => {
    fetch(apiAddress + "/char/skills/", createOptions('UPDATE', skill))
        .then((res) => res.json())
        .then((data) =>console.log('BESkills update response', data))
        .catch((reason => console.log('BESkills update catch', reason)))
}

export const SkillsDelete=(skill: ICharSkill)=> {
    fetch(apiAddress + "/char/skills/", createOptions('DELETE', skill))
        .then((res) => res.json())
        .then((data) => console.log('BESkills delete response', data))
        .catch((reason => console.log('BESkills delete catch', reason)))
}